import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import SettingsSuggestRoundedIcon from '@mui/icons-material/SettingsSuggestRounded';
import ThumbUpAltRoundedIcon from '@mui/icons-material/ThumbUpAltRounded';
import YoutubeEmbed from './YoutubeEmbed';


const items = [
  {
    icon: <SettingsSuggestRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Explorer (Live!)',
    description:
      'Monitor all journals with daily updates and take action on high risk articles or retracted articles. Easily navigate to the DOI level.',
  },
  {
    icon: <ConstructionRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Follow retraction cascade impact (Live!)',
    description:
      'See how the latest retractions impact your portfolio regardless of where they happen.',
  },
  {
    icon: <ThumbUpAltRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Explorer Enhancements (Live!)',
    description:
      'Analyse retractions and high risk articles by topic, institution or publisher.',
  },
  {
    icon: <AutoFixHighRoundedIcon sx={{ color: 'text.secondary' }} />,
    title: 'Advanced Interactive Dashboards for your portfolio (Coming soon)',
    description:
      'Obtain advanced metrics on the performance of your portfolio and compare against the market.',
  }
];

export default function PortfolioContent() {
  return (
    <Stack
      sx={{ flexDirection: 'column', alignSelf: 'center', gap: 4, maxWidth: 450 }}
    >      
      {items.map((item, index) => (
        <Stack key={index} direction="row" sx={{ gap: 2 }}>
          {item.icon}
          <div>
            <Typography gutterBottom sx={{ fontWeight: 'medium' }}>
              {item.title}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              {item.description}
            </Typography>
          </div>
        </Stack>
      ))}
      <Stack key='argos-pro-features-video' direction="row" sx={{ gap: 2 }}>
        <YoutubeEmbed embedId='FSZ6oogagCI' />
      </Stack>
    </Stack>
  );
}